
import { Component, Input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToolConfigWebhook } from '@shared/index';
import { SkillIdInputComponent } from 'src/app/shared/components/ai-bot/utils/skill-id-input/skill-id-input.component';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { SecretPlaceholderListComponent } from "../../../../../../../shared/components/secret-placeholder-list/secret-placeholder-list.component";
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-webhooks-tab-details',
  imports: [
    FormsModule,
    SkillIdInputComponent,
    SecretPlaceholderListComponent,
    ToggleSwitchModule,
    InputTextModule,
    SelectModule
],
  templateUrl: './webhooks-tab-details.component.html',
  styleUrl: './webhooks-tab-details.component.scss'
})
export class WebhooksTabDetailsComponent {
  @Input() public selectedWebhookId: string = '';
  public readonly closeDrawer = output();


  constructor(
    public rss: RouteShareService
  ) { }

  public get selectedWebhook(): ToolConfigWebhook | undefined {
    return this.customWebhooks.find((tc) => tc.id === this.selectedWebhookId);
  }

  public get customWebhooks(): ToolConfigWebhook[] {
    return this.rss.botConfig.toolConfigs.filter((tc) => tc.tool === 'webhook') as ToolConfigWebhook[];
  }

  public selectPrevRule() {
    const currentIndex = this.customWebhooks.findIndex(tc => tc.id === this.selectedWebhookId);
    let newIndex = currentIndex - 1;
    if (newIndex === -1) { newIndex = this.customWebhooks.length - 1; }
    const newWebhook = this.customWebhooks[newIndex];
    if (newWebhook) {
      this.selectedWebhookId = newWebhook.id;
    }
  }

  public selectNextRule() {
    const currentIndex = this.customWebhooks.findIndex(tc => tc.id === this.selectedWebhookId);
    let newIndex = currentIndex + 1;
    if (newIndex >= this.customWebhooks.length) { newIndex = 0; }
    const newWebhook = this.customWebhooks[newIndex];
    if (newWebhook) {
      this.selectedWebhookId = newWebhook.id;
    }
  }

  public getSkillNames(): string[] {
    const toolsWithSkillId = this.rss.botConfig.toolConfigs.filter(toolConfig => toolConfig.skillId !== '');
    return toolsWithSkillId.map(toolConfig => toolConfig.skillId + '');
  }

  public isToolValid(): boolean {
    if (this.selectedWebhook?.name.trim() == '') return false;
    if (this.selectedWebhook?.url.trim() == '') return false;
    return true;
  }

  public urlMethodOptions: SelectModule[] = [
    { label: $localize`:@@get:GET`, value: 'get' },
    { label: $localize`:@@post:POST`, value: 'post' }
  ];

  public contentTypesOptions: SelectModule[] = [
    { label: "json", value: 'application/json' },
    { label: "x-www-form-urlencoded", value: 'application/x-www-form-urlencoded' }
  ];

  public authOptions: SelectModule[] = [
    { label: $localize`:@@no-auth:Keine`, value: 'none' },
    { label: $localize`:@@basic-auth:Basic`, value: 'basic' }
  ];
}
